import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavbarRoutingModule } from './side-navbar-routing.module';
import { MaterialModule } from '../shared/material/material.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    SideNavbarRoutingModule
    
  ]
})
export class SideNavbarModule { }
